export default "__VITE_PUBLIC_ASSET__3876096b__"